import React, { useEffect, useState } from "react";
import MarketingHeader from "../components/argus/MarketingHeader";
import Footer from "../components/argus/Footer";
import { api } from "../lib/api";
import { CheckCircle2, AlertCircle } from "lucide-react";

const COMPONENTS = [
  { key: "api", label: "API" },
  { key: "database", label: "Database" },
  { key: "scanner_queue", label: "Scanner Queue" },
  { key: "cve_feed", label: "CVE Feed" },
];

export default function Status() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/status").then((r) => setData(r.data)).catch(() => setData({}));
  }, []);

  return (
    <div className="bg-paper text-ink min-h-screen flex flex-col">
      <MarketingHeader />
      <section className="flex-1 mx-auto max-w-3xl w-full px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="font-display text-5xl tracking-tight" data-testid="status-title">System Status.</h1>
        <p className="mt-3 text-ink/60">Real-time health of every ArgusSecure component. No spin.</p>

        <div className="mt-10 rounded-xl border border-line bg-panel" data-testid="status-card">
          <div className="p-6 border-b border-line flex items-center justify-between">
            <div className="flex items-center gap-3">
              <CheckCircle2 className="text-safe" />
              <span className="font-display text-2xl">All systems operational</span>
            </div>
            <span className="text-xs text-ink/50 font-mono">{data?.now?.slice(0, 19) || "—"}</span>
          </div>
          <ul className="divide-y divide-line">
            {COMPONENTS.map((c) => {
              const v = data?.[c.key];
              const ok = v === "operational";
              return (
                <li key={c.key} className="p-5 flex items-center justify-between" data-testid={`status-${c.key}`}>
                  <span className="font-medium">{c.label}</span>
                  <span className={`inline-flex items-center gap-2 text-sm ${ok ? "text-safe" : "text-sev-high"}`}>
                    {ok ? <CheckCircle2 size={16} /> : <AlertCircle size={16} />}
                    {v || "checking"}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>

        <p className="text-xs text-ink/40 mt-6">Last scan dispatched: <span className="font-mono">{data?.last_scan_at ? new Date(data.last_scan_at).toLocaleString() : "no scans yet"}</span></p>
      </section>
      <Footer />
    </div>
  );
}
